import ComponentHelper from '../../../../supers/ComponentHelper';
import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ValidationService from '../../../../services/ValidationService';
import Modal from 'react-modal';
import { view } from 'react-easy-state';
import './edit-entity-modal.css';
import RESTService from '../../../../services/RESTService';
import RoutingService from '../../../../services/RoutingService';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();

class EditEntityModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this, null, true);
		this.setInitialData(props);
	}

	setInitialData(props) {
		this.data = props.formData;
	}

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	onClose() {
		this.props.onClose();
	}

	onNameChange(evt) {
		if (VS.validateField(evt.target.value)) {
			this.data[evt.target.name] = evt.target.value;
		}
	}

	onDescChange(evt) {
		this.data.title = evt.target.value;
	}

	validateStep1() {
		if (this.data.displayName.length > 0) {
			return true;
		}
		return false;
	}

	onSaveEntity() {
		let { displayName, title, entity } = this.data;
		entity.displayName = displayName;
		entity.schema.title = title;
		connect
			.updateEntity(entity)
			.then(() => {
				this.props.onComplete();
			})
			.catch(err => {
				RS.smartError(err);
			});
		console.log(entity);
	}

	render() {
		let { isOpen } = this.props;
		let { displayName, title } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="edit-entity-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">Edit Entity</div>
				<div className="modal-body">
					<InputField
						label="Entity Name"
						name="displayName"
						type="text"
						value={displayName}
						handleChange={this.onNameChange}
						placeholder="Enter a unique name"
						required
						autoFocus
					/>
					<InputField
						label="Description"
						name="desc"
						type="text"
						value={title}
						handleChange={this.onDescChange}
						placeholder="Enter a short description of this entity"
					/>
				</div>
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.onClose}>
						Cancel
					</button>
					<button className="btn primary" onClick={this.onSaveEntity} disabled={!this.validateStep1()}>
						Save
					</button>
				</div>
			</Modal>
		);
	}
}
export default view(EditEntityModal);



// WEBPACK FOOTER //
// ./src/views/entities-panel/entity-list/entity-modal/EditEntityModal.js